import React, { useState } from "react";
import styles from "./style.module.scss";
import MeetUsWrapper from "Components/MeetUsWrapper";
import aboutbg from "Utils/Assets/Images/aboutbg.png";

const ExpectedROI = () => {
    const [investment, setInvestment] = useState(2500);

    const formatNumber = (num) => {
        return new Intl.NumberFormat("en-US").format(Math.round(num));
    };

    const mvrPrice = 0.0035;
    const targetPrice = 0.1;
    const years = 4;
    const apy = 0.2;

    const mvrPurchase = investment / mvrPrice;
    const mvrAfterStaking = mvrPurchase * Math.pow(1 + apy, years);
    const expectedValue = mvrAfterStaking * targetPrice;
    const roiRows = [
        {
            investment: "$1,000",
            purchase: "285,714 MVR",
            staking: "514,285 MVR",
            value: "$51,428",
        },
        {
            investment: "$5,000",
            purchase: "1,428,571 MVR",
            staking: "2,571,428 MVR",
            value: "$257,142",
            highlight: true,
        },
        {
            investment: "$10,000",
            purchase: "2,857,143 MVR",
            staking: "5,142,857 MVR",
            value: "$514,285",
        },
    ];

    return (
        <div className={styles.coreValues}>
            <img
                src={aboutbg}
                alt="coreValuesBg"
                className={styles.coreValuesBg}
            />
            <MeetUsWrapper>
                <div className={styles.coreValuesContent}>
                    <div className="">
                        <h1 className={styles.title}>Potential ROI</h1>
                    </div>

                    <div className={styles.cards}>
                        <div
                            className={styles.cardSmall}
                            data-aos="fade-left"
                            data-aos-duration="800"
                            data-aos-once="false"
                        >
                            <div className={styles.tableTitleContainer}>
                                <h3 className={styles.gridText}>Calculator</h3>
                            </div>

                            <div className={styles.calcBody}>
                                <div className={styles.inputBox}>
                                    <div className={styles.inputLabelArea}>
                                        <p className={styles.inputLabel}>
                                            Enter investment amount
                                        </p>
                                        <div className={styles.inputRow}>
                                            <span
                                                className={
                                                    styles.currencySymbol
                                                }
                                            >
                                                $
                                            </span>
                                            <input
                                                type="number"
                                                className={styles.calcInput}
                                                value={investment}
                                                onChange={(e) =>
                                                    setInvestment(
                                                        e.target.value,
                                                    )
                                                }
                                            />
                                        </div>
                                    </div>
                                    <div className={styles.dollarIcon}>$</div>
                                </div>

                                <div className={styles.calcDetails}>
                                    <div className={styles.rowCalc}>
                                        <p className={styles.labelMuted}>
                                            MVR Purchase <br /> ($0.0035 each)
                                        </p>
                                        <p className={styles.valueWhite}>
                                            {formatNumber(mvrPurchase)} MVR
                                        </p>
                                    </div>

                                    <div className={styles.rowCalc}>
                                        <p className={styles.labelMuted}>
                                            Total MVR After Staking <br /> (4
                                            Years, 20% APY)
                                        </p>
                                        <p className={styles.valueWhite}>
                                            {formatNumber(mvrAfterStaking)} MVR
                                        </p>
                                    </div>
                                </div>

                                <div className={styles.expectedValueContainer}>
                                    <p className={styles.expectedLabel}>
                                        Expected Value
                                    </p>
                                    <h2 className={styles.expectedResult}>
                                        ${formatNumber(expectedValue)}
                                    </h2>
                                </div>
                            </div>
                        </div>

                        <div
                            className={styles.cardLarge}
                            data-aos="fade-up"
                            data-aos-duration="800"
                            data-aos-once="false"
                        >
                            <div className={styles.tableTitleContainer}>
                                <h3 className={styles.gridText}>
                                    Expected ROI Table
                                </h3>
                            </div>

                            <div className={styles.grid}>
                                <div>
                                    <p className={styles.headerLabel}>
                                        Investment <br /> (USD)
                                    </p>
                                </div>
                                <div>
                                    <p className={styles.headerLabel}>
                                        MVR Purchase <br /> ($0.0035 each)
                                    </p>
                                </div>
                                <div>
                                    <p className={styles.headerLabel}>
                                        Total MVR After Staking <br /> (4 Years,
                                        20% APY)
                                    </p>
                                </div>
                                <div>
                                    <p className={styles.headerLabel}>
                                        Value if MVR <br /> Hits $0.10
                                    </p>
                                </div>
                            </div>

                            {roiRows.map((row, index) => (
                                <div
                                    className={`${styles.gridBottom} ${
                                        row.highlight ? styles.highlightRow : ""
                                    }`}
                                    key={index}
                                >
                                    <div>
                                        <p className={styles.gridBottomText}>
                                            {row.investment}
                                        </p>
                                    </div>
                                    <div>
                                        <p className={styles.gridBottomText}>
                                            {row.purchase}
                                        </p>
                                    </div>
                                    <div>
                                        <p className={styles.gridBottomText}>
                                            {row.staking}
                                        </p>
                                    </div>
                                    <div>
                                        <p
                                            className={`${styles.gridBottomText} ${styles.yellowText}`}
                                        >
                                            {row.value}
                                        </p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </MeetUsWrapper>
        </div>
    );
};

export default ExpectedROI;
